import utils from "./utils";

export default {
  watch: {
    "$route.query"() {
      if(this.$route){
        const query = this.$route.query;
        console.log('[queryInterceptorMixin] (watch): ', query);
        this.$store.dispatch("setupQueryParams", query);
        if (query.errorKey) {
          console.log('[queryInterceptorMixin] (error)');
          this.handleQueryError(query.errorKey);
          
          let newQuery = { ...this.$route.query };
          delete newQuery.errorKey;

          this.$router.replace({
            query: newQuery
          });
        }
      }
    },
  },
  methods: {
    /**
     * handle error in query string
     */
    async handleQueryError(errorKey) {
      if (errorKey) {
        utils.showMessage("WARNING", this.$t(errorKey));
      }
    },
  },
};
